import io from "socket.io-client";
import configdata from "../../../services/config.json";

// The socket and the REST API have to point at the same backend. This was
// hard-coded to production, so a local session sent its API calls to
// localhost:4000 while its realtime connection went to api.mypoet360.com —
// the socket could never carry events about the data on screen, and its
// handshake retried against a host that knew nothing about the session.
const apiBase =
  process.env.NODE_ENV !== "production" ? configdata.apiUrl : configdata.herokuUrl;

// config.json stores the REST base ("…/api"); socket.io attaches at the origin.
export const SOCKET_URL = apiBase.replace(/\/api\/?$/, "");

export const socket = io(SOCKET_URL, {
  // Try WebSocket first. socket.io's default order opens with HTTP long-polling
  // and only upgrades afterwards, which is what filled the network log with a
  // continuous stream of socket.io/?transport=polling XHRs; polling stays as the
  // fallback for networks that block WebSocket.
  transports: ["websocket", "polling"],
});

// Expose the singleton socket on window so ChatContext can emit "login"
// (mapping userId -> socketId on the backend) as soon as it connects.
window.socket = socket;
